import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, Typography, IconButton } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";

import PhoneIcon from "@material-ui/icons/Phone";
import PlaceIcon from "@material-ui/icons/Place";
import MailIcon from "@material-ui/icons/Mail";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";

import { useStyles } from "./Footer.css";

class Footer extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <AppBar position="static" className={classes.appbarStyle}>
          <div className={classes.sectionDesktop}>
            <Toolbar
              style={{
                paddingLeft: 50,
                paddingRight: 50,
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    width: "30%",
                    paddingTop: 30,
                    marginRight: 100,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography variant="h4">Information</Typography>
                  <ListItem>
                    <PhoneIcon style={{ marginRight: 10 }} />
                    <div>+977-9861412350</div>
                  </ListItem>
                  <ListItem>
                    <PlaceIcon style={{ marginRight: 10 }} />
                    <div>Dhapasi 44660, Kathmandu , Nepal</div>
                  </ListItem>
                  <ListItem>
                    <MailIcon style={{ marginRight: 10 }} />
                    <div>ebook@publish.com</div>
                  </ListItem>
                </div>

                <div
                  style={{
                    width: "20%",
                    paddingTop: 30,
                    marginRight: 150,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h4">Quick Links</Typography>
                  <ListItem>
                    <Link
                      to="/aboutus"
                      style={{ textDecoration: "none", color: "#ffffff" }}
                    >
                      About Us
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link
                      to="/feedback"
                      style={{ textDecoration: "none", color: "#ffffff" }}
                    >
                      Feedback
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link
                      to="faq"
                      style={{ textDecoration: "none", color: "#ffffff" }}
                    >
                      FAQ
                    </Link>
                  </ListItem>
                </div>

                <div style={{ width: "50%", paddingTop: 30 }}>
                  <Typography variant="h4">Digi-Book</Typography>
                  <div style={{ fontSize: 20, textAlign: "justify" }}>
                    Digi-Book is an digital online ecommerce for book which
                    allows the user to buy and rent their desired books online
                    and read it digitally. We also allows author to publish
                    their book online in our platform.
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton style={{ color: "#ffffff" }}>
                      <FacebookIcon />
                    </IconButton>
                    <IconButton style={{ color: "#ffffff" }}>
                      <TwitterIcon />
                    </IconButton>
                    <IconButton style={{ color: "#ffffff" }}>
                      <InstagramIcon />
                    </IconButton>
                    <IconButton style={{ color: "#ffffff" }}>
                      <YouTubeIcon />
                    </IconButton>
                  </div>
                </div>
              </div>

              <div style={{ fontSize: 16 }}>
                Copyright &#169; {new Date().getFullYear()} Digi-Book All Rights
                Reserved.
              </div>
            </Toolbar>
          </div>

          <div className={classes.sectionMobile}>
            <Toolbar
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="h5" className={classes.textStyle}>
                Digi-Book
              </Typography>

              <div
                style={{
                  padding: 10,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  fontSize: 16,
                }}
              >
                <div style={{ marginRight: 15 }}>
                  <Link
                    to="/aboutus"
                    style={{ textDecoration: "none", color: "#ffffff" }}
                  >
                    About Us
                  </Link>
                </div>
                <div style={{ marginRight: 15 }}>
                  <Link
                    to="/feedback"
                    style={{ textDecoration: "none", color: "#ffffff" }}
                  >
                    Feedback
                  </Link>
                </div>
                <div style={{ marginRight: 15 }}>
                  <Link
                    to="faq"
                    style={{ textDecoration: "none", color: "#ffffff" }}
                  >
                    FAQ
                  </Link>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6">Information</Typography>
                <ListItem>
                  <PhoneIcon style={{ marginRight: 10 }} />
                  +977-9887147852
                </ListItem>
                <ListItem>
                  <PlaceIcon style={{ marginRight: 10 }} />
                  Dhapasi, Kathmandu , Nepal
                </ListItem>
                <ListItem>
                  <MailIcon style={{ marginRight: 10 }} />
                  ebook@publish.com
                </ListItem>
              </div>

              <div style={{ textAlign: "center" }}>
                Copyright &#169; {new Date().getFullYear()} &nbsp; All Rights
                Reserved.
              </div>
            </Toolbar>
          </div>
        </AppBar>
      </div>
    );
  }
}

export default withStyles(useStyles)(Footer);
